var styles = {
  "FooterHelp": "Polaris-FooterHelp"
};

export { styles as default };
